import request from '@/utils/request'
// import { filters } from '@/filters/index.js'

// 获取后台管理员-广告主列表
export function getList(params) {
  return request({
    url: `/account_management/advertiser_users`,
    method: 'get',
    params
  })
}

// 绑定后台管理员和广告主
export function bindAdminAdvert(data = {}) {
  return request({
    url: '/account_management/advertiser_users',
    method: 'post',
    data
  })
}

// 后台用户-广告主解绑
export function deleAdminAdvert(id) {
  return request({
    url: `/account_management/advertiser_users/${id}`,
    method: 'delete'
  })
}
